import { F18_SERVICES } from '../configs/Config'
import { apiCMSWithToken } from './axios'
import { apiBaseCMSWithToken } from './axiosBase'
import { apiLandingCMSWithToken } from './axiosLanding'

export async function postSearch(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postSearch}?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function projectSearch(filters = {}, page = '', pageSize = '') {
  try {
    const params = new URLSearchParams({ page, pageSize, ...filters })
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.projects}?${params.toString()}`
    )

    return response
  } catch (error) {
    console.error('Error in listCustomer:', error)
    throw error
  }
}
export const getProjectLibraryListForWeb = async () => {
  try {
    const response = await apiBaseCMSWithToken.get(
      `/landing/v1/public/project-library/list-for-web?page=1&pageSize=100000`,
      { tokenKey: 'tokenWeb' }
    )
    return response
  } catch (error) {
    console.error('Error fetching posts:', error)
    throw error
  }
}

export async function addressSearch(
  filters = {},
  type = '',
  page = '',
  pageSize = ''
) {
  try {
    const params = new URLSearchParams({ page, pageSize, ...filters })
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.address}/${type}?${params.toString()}`
    )

    return response
  } catch (error) {
    console.error('Error in listCustomer:', error)
    throw error
  }
}

export async function upLoadImage(body) {
  // const response = await apiCMSWithToken.post(F18_SERVICES.upload, body)
  const response = await apiCMSWithToken.post(F18_SERVICES.upload, body, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response
}

export async function upLoadImagePrivate(body) {
  // const response = await apiCMSWithToken.post(F18_SERVICES.upload, body)
  const response = await apiCMSWithToken.post(F18_SERVICES.uploadImgPrivate, body, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response
}

export async function postAdd(body) {
  const response = await apiCMSWithToken.post(
    `${F18_SERVICES.postAction}/add`,
    body
  )
  return response
}
export async function postUpdate(body, id) {
  const response = await apiCMSWithToken.put(
    `${F18_SERVICES.postAction}/update/${id}`,
    body
  )
  return response
}

export async function postDetail(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postAction}/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function showPostPhone(id, from = 1) {
  const response = await apiCMSWithToken.get(
    `${F18_SERVICES.postAction}/${id}/show-phone?from=${from}`
  )
  return response
}

export async function postCommunityDetail(filters = {}, id) {
  try {
    const params = new URLSearchParams({ ...filters })
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postAction}/${id}?${params.toString()}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function postImportExcel(body) {
  const response = await apiCMSWithToken.post(
    // `${F18_SERVICES.post}/import/excel`,
    `/post/app/import/excel`,
    body,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return response
}

export async function postImportCommunityExcel(body) {
  const response = await apiCMSWithToken.post(
    // `${F18_SERVICES.post}/import/excel`,
    `/post/community/import/excel`,
    body,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return response
}

export async function getUserManagePost(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postAction}/manager_post/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function getListStaff(filters = {}, page = '', pageSize = '') {
  try {
    const params = new URLSearchParams({ page, pageSize, ...filters })
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.user}/list-staff?${params.toString()}`
    )

    return response
  } catch (error) {
    console.error('Error in listCustomer:', error)
    throw error
  }
}

export async function listNote(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postAction}/post-history?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function noteAdd(body) {
  const response = await apiCMSWithToken.post(
    `${F18_SERVICES.postAction}/note`,
    body
  )
  return response
}

export async function noteUpdate(body, id) {
  const response = await apiCMSWithToken.put(
    `${F18_SERVICES.postAction}/note/${id}`,
    body
  )
  return response
}

export async function noteDelete(body) {
  const response = await apiCMSWithToken.delete(
    `${F18_SERVICES.postAction}/post-history`,
    {
      data: body
    }
  )
  return response
}

export async function listUserPost(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postAction}/manager_post/${id}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function userPostAdd(body) {
  const response = await apiCMSWithToken.post(
    `${F18_SERVICES.postAction}/manager_post`,
    body
  )
  return response
}

export async function userPostDelete(body) {
  const response = await apiCMSWithToken.delete(
    `${F18_SERVICES.postAction}/manager_post`,
    {
      data: body
    }
  )
  return response
}

export async function postSearchWeb(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postSearch}?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function postDelete(body) {
  const response = await apiCMSWithToken.delete(`post/deletes`, {
    data: body
  })
  return response
}

export async function getListUserDepartment(
  filters = {},
  page = '',
  pageSize = ''
) {
  try {
    const params = new URLSearchParams({ page, pageSize, ...filters })
    // const response = await apiCMSWithToken.get(
    //   `/department/user?${params.toString()}`
    // )
    const response = await apiCMSWithToken.get(
      `/user/list-staff-department?${params.toString()}`
    )

    return response
  } catch (error) {
    console.error('Error in listCustomer:', error)
    throw error
  }
}

export async function listHistory(filters = {}, id) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postAction}/post-history/${id}?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function postHistory(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postAction}/post-history/?${params}&type=2&type=3&type=6&type=7&type=5&type=8`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}
export async function postHistoryBook(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postAction}/book-history/${id}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function addressSearchAll(type = '') {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.address}/${type}/all`
    )

    return response
  } catch (error) {
    console.error('Error in listCustomer:', error)
    throw error
  }
}

export async function postCommunityHistory(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postAction}/post-history/?${params}&type=2&type=3&type=6&type=7&type=8`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function requestDetail(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.postAction}/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}
export async function requestDetailInfoPost(id) {
  try {
    const response = await apiBaseCMSWithToken.get(
      `/jv-api/landing/public/post/get-detail-info?id=${id}`,
      { tokenKey: 'tokenWeb' }
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}
export async function upLoadImagePostWeb(files = []) {
  // const response = await apiCMSWithToken.post(F18_SERVICES.upload, body)
  const formData = new FormData()

  // append từng file vào key "file"
  files.forEach((file) => {
    formData.append('file', file)
  })
  const response = await apiBaseCMSWithToken.post(
    '/landing/v1/public/post/upload-files',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      tokenKey: 'tokenWeb'
    }
  )
  return response
}
export async function updateDetailPostWeb(body) {
  // const response = await apiCMSWithToken.post(F18_SERVICES.upload, body)
  
  const response = await apiBaseCMSWithToken.put(
    '/landing/v1/public/post',
    body,
    {
      tokenKey: 'tokenWeb'
    }
  )
  return response
}

export default {
  postSearch,
  projectSearch,
  addressSearch,
  upLoadImage,
  postAdd,
  postUpdate,
  postDetail,
  postImportExcel,
  getUserManagePost,
  getListStaff,
  listNote,
  noteAdd,
  noteDelete,
  listUserPost,
  userPostAdd,
  userPostDelete,
  noteUpdate,
  postSearchWeb,
  postCommunityDetail,
  postImportCommunityExcel,
  postDelete,
  getListUserDepartment,
  listHistory,
  postHistory,
  postHistoryBook,
  addressSearchAll,
  postCommunityHistory
}
